import * as Sentry from '@sentry/react';

export const initSentry = () => {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  
  // Only initialize if DSN is provided
  if (!dsn) {
    console.warn('Sentry DSN not configured - error tracking disabled');
    return;
  }

  Sentry.init({
    dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_RELEASE,
    
    // Filter out known errors
    beforeSend(event, hint) {
      const error = hint.originalException;
      
      // Filter out certain errors
      if (error && typeof error === 'object' && 'message' in error) {
        const message = String(error.message);
        
        // Ignore network errors that are expected
        if (message.includes('Failed to fetch') && message.includes('NetworkError')) {
          return null;
        }
        
        // Ignore cancelled requests
        if (message.includes('AbortError')) {
          return null;
        }
      }
      
      return event;
    },
  });
};

export const captureGeocodingError = (companyId: string, address: string, error: unknown) => {
  Sentry.captureException(error, {
    tags: {
      feature: 'geocoding',
    },
    contexts: {
      geocoding: {
        address,
      },
    },
  });
};

export const captureAuthError = (userId: string | null, role: string | null, error: unknown) => {
  Sentry.captureException(error, {
    tags: {
      feature: 'authentication',
      user_role: role,
    },
  });
};

export { Sentry };
